module.exports = __webpack_public_path__ + "img/1.3ebe8e3f.png";